import React, { useRef, useEffect } from 'react';

import PropTypes from 'prop-types';

import '@hotmart/cosmos/dist/modal';
import '@hotmart/cosmos/dist/modal/modal-body';
import '@hotmart/cosmos/dist/modal/modal-footer';
import '@hotmart/cosmos/dist/modal/modal-header';

/**
 * @deprecated The method should not be used.
 */
const Modal = ({
  onClose,
  bodyClass = '',
  centered = true,
  children = null,
  className = '',
  footer = null,
  footerClass = '',
  header = null,
  headerClass = '',
  open = false
}) => {
  const modalRef = useRef(null);

  const eventListeners = () => {
    modalRef.current?.addEventListener('close', onClose);
  };

  useEffect(eventListeners, []);

  useEffect(() => {
    const closingModal = !open;

    if (closingModal) {
      onClose();
    }
  }, [open]);

  return (
    <hot-modal
      ref={modalRef}
      {...(open && { open: true })}
      position={centered ? 'centered' : ''}
      class={className}
    >
      {header && (
        <hot-modal-header class={headerClass}>{header}</hot-modal-header>
      )}
      <hot-modal-body class={bodyClass}>{children}</hot-modal-body>
      {footer && (
        <hot-modal-footer class={footerClass}>{footer}</hot-modal-footer>
      )}
    </hot-modal>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  bodyClass: PropTypes.string,
  centered: PropTypes.bool,
  children: PropTypes.element,
  className: PropTypes.string,
  footer: PropTypes.element,
  footerClass: PropTypes.string,
  header: PropTypes.element,
  headerClass: PropTypes.string,
  open: PropTypes.bool
};

export default Modal;
